import type { ISensemakerOverviewResponse } from '@brushfire/types'
import { apiClient } from '@/api/http/client'
import type { ApiResponse } from '@/api/http/types'

export async function fetchSensemakerOverview(
  tenantId: string,
): Promise<ISensemakerOverviewResponse> {
  const { data } = await apiClient.get<ApiResponse<ISensemakerOverviewResponse>>(
    `/api/v1/platform/sensemakers/${encodeURIComponent(tenantId)}`,
  )
  if (!data.data) {
    throw new Error('Sensemaker overview not found')
  }
  return data.data
}
